import { render } from "./BotaoFixo.vue?vue&type=template&id=3290bc9b&scoped=true"
const script = {}

import "./BotaoFixo.vue?vue&type=style&index=0&id=3290bc9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3290bc9b"]])

export default __exports__